import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    quizId: undefined,
    modal: false,
    quizInfo: {
        quizs: []
    }
};

const quizSlice = createSlice({
    name: "quiz",
    initialState,
    reducers: {
        quizEditMode: (state, action) => {
            if (state.quizId === action.payload) {
                state.quizId = undefined
            } else {
                state.quizId = action.payload
            }
        },
        quizAddModal: (state, action) => {
            if (state.modal) {
                state.modal = false
            } else {
                state.modal = true
            }
        },
    },
});

export const { quizEditMode, quizAddModal } = quizSlice.actions;
export default quizSlice.reducer;
